// extracted by mini-css-extract-plugin
export default {"V2Operate":"V2Operate--GQfxD","v2Ghost":"v2Ghost--PcUdn"};